import { apiAgents } from "../../axios/apiAgentsInstance";

export const createAgent = async ({ token, payload }) => {
	try {
		const res = await apiAgents.post(
			`/register`,
			payload,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			}
		);

		return res.data;
	} catch (err) {
		console.error('Error AL CREAR:', err);
		const backendMessage = err?.response?.data?.detail || err?.response?.data?.message;
		const error = new Error(backendMessage || err.message || 'Error creating agent');
		error._raw = err;
		throw error;
	}
};